<template>
  <b-modal id="create-expense-modal" no-close-on-backdrop title="Add Expense" hide-footer>
    <loading-screen :is-loading="isSaving"></loading-screen>
    <errors :error-list="serverErrors"></errors>

    <!-- Create new expense -->
    <div>
      <form @submit.prevent="createNewExpense">

        <div class="form-group mb-4">
          <label>Description</label>
          <textarea v-model="newExpense.description" name="description" id="description" rows="2"
            class="form-control"></textarea>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-4">
              <label for="amount">Currency</label>
              <div class="btn-group">
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'GBP' }"
                  @click="setCurrency('GBP')">
                  £
                </button>
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'USD' }"
                  @click="setCurrency('USD')">
                  $
                </button>
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'JPY' }"
                  @click="setCurrency('JPY')">
                  ¥
                </button>
                <button type="button" class="btn btn-itg" :class="{ 'active': newExpense.currency === 'AUD' }"
                  @click="setCurrency('AUD')">
                  AU$
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group mb-4">
              <label for="amount">Amount</label>
              <input v-model="newExpense.amount" name="amount" id="amount" class="form-control" min="0" step="0.01"
                type="number">
            </div>
          </div>
        </div>

        <button type="submit" class="btn btn-itg-dark" :disabled="isSaving" @click.prevent="createNewExpense">Create
          Expense
        </button>

      </form>
    </div>
    <!-- / Create new expense -->

  </b-modal>
</template>

<script>
import axios from "axios";
import Forms from "../../../../../../mixins/Forms";
import { mapGetters } from "vuex";

export default {
  name: "CreateExpenseModal",
  props: ['ticketId'],
  data() {
    return {
      isLoading: false,
      isSaving: false,
      serverErrors: [],

      newExpense: {
        description: '',
        currency: 'GBP',
        amount: null
      }
    }
  },
  mixins: [Forms],
  methods: {
    setCurrency(currency) {
      this.newExpense.currency = currency;
    },

    getFormData() {
      return {
        description: this.newExpense.description,
        currency: this.newExpense.currency,
        amount: Number(this.newExpense.amount)*100
      };
    },

    createNewExpense() {
      let vm = this;
      vm.serverErrors = [];
      vm.isSaving = true;

      axios.post(API_BASE + '/tickets/' + this.ticket.id + '/expenses', this.getFormData()).then(r => {
        vm.isSaving = false;
        vm.newExpense = {
          description: '',
          currency: 'GBP',
          amount: null
        };
        this.$notify.success({
          title: 'Success!',
          message: 'Expense added successfully'
        });
        this.$emit('expense-added');
        this.$bvModal.hide('create-expense-modal');
      }).catch(e => {
        console.log(e);
        vm.isSaving = false;
        vm.setErrors(e);
      });
    }
  },
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket'
    })
  }
}
</script>

<style scoped></style>
